import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import {
  errorB2cCatalogsList,
  errorDeletePlan,
  errorFreeTrialTemplatePlan,
  errorGetPlanList,
  errorRetriveB2cCatalogsList,
  errorSetPlanList,
  errorUpdatePlan,
  successB2cCatalogsList,
  successDeletePlan,
  successFreeTrialTemplatePlan,
  successGetPlanList,
  successRetriveB2cCatalogsList,
  successSetPlanList,
  successUpdatePlan,
  successB2CLatestPurchases,
  errorB2CLatestPurchases,
  successB2CDashTrendingLabs,
  errorB2CDashTrendingLabs,
  successB2CVmLabsList,
  errorB2CVmLabsList,
  successAddLabIntoCart,
  errorAddLabIntoCart,
  successUserCartDetails,
  errorUserCartDetails,
  successDeleteItemCart,
  errorDeleteItemCart,
  successB2cCheckout,
  errorB2cCheckout,
  successPaymentCallback,
  errorPaymentCallback,
  successPaymentReceipt,
  errorPaymentReceipt,
  successApplyDiscount,
  errorApplyDiscount,
  successRetrievePlanList,
  errorRetrievePlanList,
  successUpdateCatalogB2cPlanMap,
  errorUpdateCatalogB2cPlanMap,
} from "../actions";
import {
  createPlanList,
  createFreeTrialTemplate,
  deletePlanApi,
  fetchPlanList,
  getB2cCatalogsListApi,
  updatePlanApi,
  getB2CLatestPurchasesApi,
  getB2CDashTrendingLabsApi,
  getB2CVmLabsApi,
  addLabIntoCartApi,
  getUserCartDetailsApi,
  deleteItemToCartApi,
  b2cCheckoutApi,
  paymentCallbackApi,
  paymentReceiptApi,
  applyDiscountApi,
  fetchRetrievePlanList,
  updateCatalogPlan,
} from "../api/b2c";
import { b2c } from "../../constants/actionTypes";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";

export function* getPlanListFunction({ payload }) {
  try {
    const data = yield call(fetchPlanList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successGetPlanList(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorGetPlanList(data));
    }
  } catch (err) {
    yield put(errorGetPlanList(err));
  }
}

export function* retrievePlanListFunction({ payload }) {
  try {
    const data = yield call(fetchRetrievePlanList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successRetrievePlanList(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorRetrievePlanList(data));
    }
  } catch (err) {
    yield put(errorRetrievePlanList(err));
  }
}

export function* updateCatalogPlanMap({ id, payload }) {
  try {
    const data = yield call(updateCatalogPlan, id, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, "Catalogue plans updated successfully");
      yield put(successUpdateCatalogB2cPlanMap(data?.data));
    } else {
      yield put(errorUpdateCatalogB2cPlanMap(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(errorUpdateCatalogB2cPlanMap(err));
  }
}

export function* createPlanListFunction({ payload }) {
  try {
    const data = yield call(createPlanList, payload);
    if (data?.status === statusCode.Created201) {
      yield put(successSetPlanList(data));
      toastNotification(toasterFlags.SUCCESS, "operation completed successfully");
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorSetPlanList(data));
    }
  } catch (err) {
    yield put(errorSetPlanList(err));
  }
}
export function* deletePlanFunction({ payload }) {
  try {
    const data = yield call(deletePlanApi, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, data?.data?.success);
      yield put(successDeletePlan(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorDeletePlan(data));
    }
  } catch (err) {
    yield put(errorDeletePlan(err));
  }
}

export function* updatePlanFunction({ payload, id }) {
  try {
    const data = yield call(updatePlanApi, id, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successUpdatePlan(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorUpdatePlan(data));
    }
  } catch (err) {
    yield put(errorUpdatePlan(err));
  }
}

export function* createFreeTrialTemplateFunction({ payload, id }) {
  try {
    const data = yield call(createFreeTrialTemplate, id, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successFreeTrialTemplatePlan(data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorFreeTrialTemplatePlan(data));
    }
  } catch (err) {
    yield put(errorFreeTrialTemplatePlan(err));
  }
}

export function* getB2cCatalogsListFunction({ payload }) {
  try {
    const data = yield call(getB2cCatalogsListApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successB2cCatalogsList(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorB2cCatalogsList(data));
    }
  } catch (err) {
    yield put(errorB2cCatalogsList(err));
  }
}

export function* retriveB2cCatalogsListFunction({ payload }) {
  try {
    const data = yield call(getB2cCatalogsListApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successRetriveB2cCatalogsList(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorRetriveB2cCatalogsList(data));
    }
  } catch (err) {
    yield put(errorRetriveB2cCatalogsList(err));
  }
}

export function* getB2CLatestPurchases({ payload }) {
  try {
    const data = yield call(getB2CLatestPurchasesApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successB2CLatestPurchases(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorB2CLatestPurchases(data));
    }
  } catch (err) {
    yield put(errorB2CLatestPurchases(err));
  }
}

export function* getB2CDashTrendingLabs({ payload }) {
  try {
    const data = yield call(getB2CDashTrendingLabsApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successB2CDashTrendingLabs(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorB2CDashTrendingLabs(data));
    }
  } catch (err) {
    yield put(errorB2CDashTrendingLabs(err));
  }
}

export function* getB2CVMLabs({ payload }) {
  try {
    const data = yield call(getB2CVmLabsApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successB2CVmLabsList(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorB2CVmLabsList(data));
    }
  } catch (err) {
    yield put(errorB2CVmLabsList(err));
  }
}

export function* addLabIntoCartFunction({ payload }) {
  try {
    const data = yield call(addLabIntoCartApi, payload);
    if (data?.status === statusCode.Created201 || data?.status === statusCode.Ok200) {
      if (data?.status === statusCode.Created201) {
        toastNotification(toasterFlags.SUCCESS, "item added to the cart successfully");
      }
      yield put(successAddLabIntoCart(data));
    } else {
      if (data?.data?.type !== "Model_Open") {
        toastNotification(toasterFlags.WARN, data?.data?.message);
      }
      if (data?.data?.message?.sku_id) {
        toastNotification(toasterFlags.WARN, data?.data?.message?.sku_id[0]);
      }
      yield put(errorAddLabIntoCart(data));
    }
  } catch (err) {
    yield put(errorAddLabIntoCart(err));
  }
}

export function* getUserCartDetailsFunction({ payload }) {
  try {
    const data = yield call(getUserCartDetailsApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successUserCartDetails(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorUserCartDetails(data));
    }
  } catch (err) {
    yield put(errorUserCartDetails(err));
  }
}

export function* applyDiscountFunction({ id, payload }) {
  try {
    const data = yield call(applyDiscountApi, id, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successApplyDiscount(data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success[0]);
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorApplyDiscount(data));
    }
  } catch (err) {
    yield put(errorApplyDiscount(err));
  }
}

export function* deleteItemToCartFunction({ payload }) {
  try {
    const data = yield call(deleteItemToCartApi, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags?.SUCCESS, data?.data?.success);
      yield put(successDeleteItemCart(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorDeleteItemCart(data));
    }
  } catch (err) {
    yield put(errorDeleteItemCart(err));
  }
}

export function* b2cCheckoutFunction({ payload }) {
  try {
    const data = yield call(b2cCheckoutApi, payload);
    if (data?.status === statusCode.Created201) {
      yield put(successB2cCheckout(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorB2cCheckout(data));
    }
  } catch (err) {
    yield put(errorB2cCheckout(err));
  }
}

export function* paymentCallbackFunction({ payload }) {
  try {
    const data = yield call(paymentCallbackApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successPaymentCallback(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorPaymentCallback(data));
    }
  } catch (err) {
    yield put(errorPaymentCallback(err));
  }
}

export function* paymentReceiptFunction({ payload }) {
  try {
    const data = yield call(paymentReceiptApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successPaymentReceipt(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorPaymentReceipt(data));
    }
  } catch (err) {
    yield put(errorPaymentReceipt(err));
  }
}

export function* b2cRootSaga() {
  yield takeLatest(b2c?.REQUEST_GET_PLAN_LIST, getPlanListFunction);
  yield takeLatest(b2c?.REQUEST_RETRIEVE_PLAN_LIST, retrievePlanListFunction);
  yield takeLatest(b2c?.REQUEST_UPDATE_CATALOG_B2C_PLAN_MAP, updateCatalogPlanMap);
  yield takeLatest(b2c?.REQUEST_SET_PLAN_LIST, createPlanListFunction);
  yield takeLatest(b2c?.REQUEST_DELETE_PLAN, deletePlanFunction);
  yield takeLatest(b2c?.REQUEST_UPDATE_PLAN, updatePlanFunction);
  yield takeLatest(b2c?.CREATE_FREE_TRIAL_TEMPLATE, createFreeTrialTemplateFunction);
  yield takeLatest(b2c?.GET_B2C_CATALOGS_LIST, getB2cCatalogsListFunction);
  yield takeLatest(b2c?.RETRIVE_B2C_CATALOG_LIST, retriveB2cCatalogsListFunction);
  yield takeLatest(b2c?.REQUEST_GET_LATEST_PURCHASES, getB2CLatestPurchases);
  yield takeLatest(b2c?.GET_B2C_TRENDING_LABS, getB2CDashTrendingLabs);
  yield takeLatest(b2c?.GET_B2C_VM_LABS_LIST, getB2CVMLabs);
  yield takeLatest(b2c?.REQUEST_ADD_LAB_INTO_CART, addLabIntoCartFunction);
  yield takeLatest(b2c?.RETRIVE_USER_CART_DETAILS, getUserCartDetailsFunction);
  yield takeLatest(b2c?.REQUEST_DELETE_ITEM_TO_CART, deleteItemToCartFunction);
  yield takeLatest(b2c?.REQUEST_B2C_CHECKOUT, b2cCheckoutFunction);
  yield takeLatest(b2c?.REQUEST_PAYMENT_CALLBACK, paymentCallbackFunction);
  yield takeLatest(b2c?.REQUEST_PAYMENT_RECEIPT, paymentReceiptFunction);
  yield takeLatest(b2c?.REQUEST_APPLY_DISCOUNT, applyDiscountFunction);
}

export default function* rootSaga() {
  yield all([fork(b2cRootSaga)]);
}
